"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationAddressType = void 0;
var LocationAddressType;
(function (LocationAddressType) {
    LocationAddressType[LocationAddressType["Airport"] = 0] = "Airport";
    LocationAddressType[LocationAddressType["Port"] = 1] = "Port";
    LocationAddressType[LocationAddressType["Venice"] = 2] = "Venice";
    LocationAddressType[LocationAddressType["Dubrovnik"] = 3] = "Dubrovnik";
    LocationAddressType[LocationAddressType["Incomplete"] = 4] = "Incomplete";
    LocationAddressType[LocationAddressType["MeetingPosition"] = 5] = "MeetingPosition";
    LocationAddressType[LocationAddressType["Train"] = 6] = "Train";
})(LocationAddressType || (exports.LocationAddressType = LocationAddressType = {}));
//# sourceMappingURL=LocationAddressType.js.map